import { FileDefinitionDTO } from "../DTO/fileDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateFileDefinitionRequest extends BasicRequest{
   
    public fileDefinition! : FileDefinitionDTO;
    public indexTracker? : {originalIndex:number,currentIndex:number}[];
    
    constructor(){
        super();
    }
}